<template>
    <div class="row">
        <div class="documentation">
            <div class="documentation-grid" :class="gridModClass">
                <div v-if="!this.guest || this.client === 'neostores' || this.client === 'neo-office' || this.client === 'neopharm' || this.client === 'avesta'" class="docnav-item" :class="{ 'is-open': refsNavOpen }">
                    <div id="doc_edit_link"></div>
                    <button v-if="listpage" class="docnav-item-control docnav-item-control_accordion reset-btn" @click.prevent="toggleGroup">
                        <svg class="docnav-item-control__icon" width="16" height="16" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g fill-rule="evenodd" clip-rule="evenodd" fill="currentColor">
                                <path
                                    d="M1 2h3v1.813H1V2zm0 2.75v7.5h3v-7.5H1zM1 15v-1.813h3V15H1zM0 2a1 1 0 011-1h3a1 1 0 011 1v13a1 1 0 01-1 1H1a1 1 0 01-1-1V2zm3 4.625H2v3.75h1v-3.75z" />
                                <path
                                    d="M5 2h3v1.813H5V2zm0 2.75v7.5h3v-7.5H5zM5 15v-1.813h3V15H5zM4 2a1 1 0 011-1h3a1 1 0 011 1v13a1 1 0 01-1 1H5a1 1 0 01-1-1V2zm3 4.625H6v3.75h1v-3.75z" />
                                <path
                                    d="M9.366 1.803l2.755-.61.41 1.85-2.756.61-.41-1.85zm.617 2.791l1.667 7.533 2.756-.61-1.667-7.533-2.756.61zm2.285 10.324l-.41-1.85 2.756-.61.41 1.85-2.756.61zM8.389 2.019A1 1 0 019.15.827l2.757-.61a1 1 0 011.192.76L16 14.092a1 1 0 01-.76 1.192l-2.756.61a1 1 0 01-1.193-.76L8.39 2.019zm3.86 4.048l-.942.208.834 3.767.941-.208-.833-3.767z" />
                            </g>
                        </svg>
                        <span class="docnav-item-control__txt">Документы</span>
                        <svg class="docnav-item-control__toggle d-xl-none" width="24" height="24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 19l-8-7 8-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                    <button v-else class="docnav-item-control reset-btn" @click.prevent="toggleItemControl('refsNavOpen')">
                        <svg class="docnav-item-control__icon" width="16" height="16" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <g fill-rule="evenodd" clip-rule="evenodd" fill="currentColor">
                                <path
                                    d="M1 2h3v1.813H1V2zm0 2.75v7.5h3v-7.5H1zM1 15v-1.813h3V15H1zM0 2a1 1 0 011-1h3a1 1 0 011 1v13a1 1 0 01-1 1H1a1 1 0 01-1-1V2zm3 4.625H2v3.75h1v-3.75z" />
                                <path
                                    d="M5 2h3v1.813H5V2zm0 2.75v7.5h3v-7.5H5zM5 15v-1.813h3V15H5zM4 2a1 1 0 011-1h3a1 1 0 011 1v13a1 1 0 01-1 1H5a1 1 0 01-1-1V2zm3 4.625H6v3.75h1v-3.75z" />
                                <path
                                    d="M9.366 1.803l2.755-.61.41 1.85-2.756.61-.41-1.85zm.617 2.791l1.667 7.533 2.756-.61-1.667-7.533-2.756.61zm2.285 10.324l-.41-1.85 2.756-.61.41 1.85-2.756.61zM8.389 2.019A1 1 0 019.15.827l2.757-.61a1 1 0 011.192.76L16 14.092a1 1 0 01-.76 1.192l-2.756.61a1 1 0 01-1.193-.76L8.39 2.019zm3.86 4.048l-.942.208.834 3.767.941-.208-.833-3.767z" />
                            </g>
                        </svg>
                        <span class="docnav-item-control__txt">Документы</span>
                        <svg class="docnav-item-control__toggle" width="24" height="24" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 19l-8-7 8-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                    <div class="docnav-panel">
                        <div class="docnavsearch">
                            <div class="docnavsearch-input-wrap">
                                <div class="search-control">
                                    <button @click="navSearch" ref="searchInput" id="search-control__input" class="justify-content-center form-control">
                                        Поиск
                                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none"
                                             xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M7.8 0C9.86869 0 11.8526 0.782651 13.3154 2.17578C14.7782 3.56891 15.6 5.45839 15.6 7.42857C15.6 9.26857 14.892 10.96 13.728 12.2629L14.052 12.5714H15L21 18.2857L19.2 20L13.2 14.2857V13.3829L12.876 13.0743C11.508 14.1829 9.732 14.8571 7.8 14.8571C5.73131 14.8571 3.74735 14.0745 2.28457 12.6814C0.821783 11.2882 0 9.39875 0 7.42857C0 5.45839 0.821783 3.56891 2.28457 2.17578C3.74735 0.782651 5.73131 0 7.8 0ZM7.8 2.28571C4.8 2.28571 2.4 4.57143 2.4 7.42857C2.4 10.2857 4.8 12.5714 7.8 12.5714C10.8 12.5714 13.2 10.2857 13.2 7.42857C13.2 4.57143 10.8 2.28571 7.8 2.28571Z"
                                                fill="currentColor"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div class="docnavsearch-refs docnavsearch-suggestions"
                                    :class="{ 'is-hidden': suggestionsHidden }">
                                </div>
                            </div>
							<div class="docnavsearch-refs">
                                <div v-if="!searchResult[0]" v-for="software in software" class="docnavsearch-refs-group">
                                    <button
                                        :id="software.id"
                                        class="docnavsearch-refs-group-control reset-btn"
                                        :class="getDocnavGroupIDs(software.id)"
                                        v-if="!this.guest || this.client === 'neostores' || this.client === 'neo-office' || this.client === 'neopharm' || this.client === 'avesta'"
                                        @click.prevent="toggleGroup"
                                    >
                                        <span>{{ software.name }}</span>
                                        <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.5 5.5l-5 5-5-5" stroke="currentColor" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </button>

									<div class="docnavsearch-refs-group-panel">
										<div v-for="version in software.versions">
											<div v-for="doc in version.docs">
												<a v-if="client"
													v-bind:href="'/docs/' + client + '/' + software.url + '/' + version.number + '/' + doc.url"
													class="docnavsearch-refs-link">
													<span>{{ doc.name }}</span>
												</a>
												<span v-else class="docnavsearch-refs-link">
													{{ doc.name }}
												</span>
											</div>
										</div>
									</div>
                                </div>

                                <div v-else v-for="software in searchResult" class="docnavsearch-refs-group">
                                    <button
                                        :id="software.id"
                                        class="docnavsearch-refs-group-control reset-btn"
                                        :class="getDocnavGroupIDs(software.id)"
                                        v-if="!this.guest || this.client === 'neostores' || this.client === 'neo-office' || this.client === 'neopharm' || this.client === 'avesta'"
                                        @click.prevent="toggleGroup"
                                    >
                                        <span>{{ software.name }}</span>
                                        <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.5 5.5l-5 5-5-5" stroke="currentColor" stroke-linecap="round"
                                                stroke-linejoin="round" />
                                        </svg>
                                    </button>

									<div class="docnavsearch-refs-group-panel">
										<div v-for="version in software.versions">
											<div v-for="doc in version.docs">
												<a v-if="client"
													v-bind:href="'/docs/' + client + '/' + software.url + '/' + version.number + '/' + doc.url"
													class="docnavsearch-refs-link">
													<span>{{ doc.name }}</span>
												</a>
												<span v-else class="docnavsearch-refs-link">
													{{ doc.name }}
												</span>
											</div>
										</div>
									</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="!listpage" class="docnav-container"  :class="{ 'is-open': indexNavOpen }">
                    <div class="docnav-item mb24" v-if="!this.guest || this.client === 'neostores' || this.client === 'neo-office' || this.client === 'neopharm' || this.client === 'avesta'" :class="{ 'is-open': indexNavOpen }">
                        <button class="docnav-item-control reset-btn" v-if="!this.guest || this.client === 'neostores' || this.client === 'neo-office' || this.client === 'neopharm' || this.client === 'avesta'" @click.prevent="screenWidth > 1200 ? toggleItemControl('indexNavOpen') : null">
                            <svg class=" docnav-item-control__icon" width="17" height="16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <rect x="1.5" y=".5" width="13" height="15" rx=".5" stroke="currentColor" />
                                <circle cx="5" cy="4" r="1" fill="currentColor" />
                                <circle cx="5" cy="8" r="1" fill="currentColor" />
                                <circle cx="5" cy="12" r="1" fill="currentColor" />
                                <path d="M8 4h4M8 8h4M8 12h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                            <span class="docnav-item-control__txt">Содержание</span>
                            <svg v-if="screenWidth > 1200" class="docnav-item-control__toggle" width="24" height="24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M16 19l-8-7 8-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </button>
                        <div class="docnav-panel">
                            <div class="docnavindex">
                                <!-- <div class="docnavindex__item">Оглавление</div> -->
                                <div v-for="page in content" class="docnavindex__item">
									<a v-bind:href="currurl + '/' + page.url" class="docnavindex-link"
										:class="{ 'is-selected': page.url == pagedetail.url }">
										{{ page.title }}
									</a>
									<div v-for="child in page.child" class="docnavindex__item">
										<a v-bind:href="currurl + '/' + child.url" class="docnavindex-link"
											:class="{ 'is-selected': child.url == pagedetail.url }">
											{{ child.title }}
										</a>
									</div>
                                </div>
                            </div>
                        </div>
                    </div>

<!--                    <div v-if="release.length > 0" class="docnav-item" :class="{ 'is-open': indexNavOpen }">-->
<!--                        <button class="docnav-item-control reset-btn" v-if="!this.guest || this.client === 'neostores'" @click.prevent="toggleItemControl('indexNavOpen')">-->
<!--                            <svg class=" docnav-item-control__icon" width="17" height="16" fill="none"-->
<!--                                xmlns="http://www.w3.org/2000/svg">-->
<!--                                <rect x="1.5" y=".5" width="13" height="15" rx=".5" stroke="currentColor" />-->
<!--                                <circle cx="5" cy="4" r="1" fill="currentColor" />-->
<!--                                <circle cx="5" cy="8" r="1" fill="currentColor" />-->
<!--                                <circle cx="5" cy="12" r="1" fill="currentColor" />-->
<!--                                <path d="M8 4h4M8 8h4M8 12h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />-->
<!--                            </svg>-->
<!--                            <span class="docnav-item-control__txt">Релизы</span>-->
<!--                            <svg class="docnav-item-control__toggle" width="24" height="24" fill="none"-->
<!--                                xmlns="http://www.w3.org/2000/svg">-->
<!--                                <path d="M16 19l-8-7 8-7" stroke="currentColor" stroke-width="2" stroke-linecap="round"-->
<!--                                    stroke-linejoin="round" />-->
<!--                            </svg>-->
<!--                        </button>-->
<!--                        <div class="docnav-panel">-->
<!--                            <div class="docnavindex">-->
<!--                                <div class="docnavindex__item">Релизы</div>-->
<!--                                <div v-for="page in release" class="docnavindex__item">-->
<!--									<a v-bind:href="currurl + '/' + page.url + '/release'" class="docnavindex-link"-->
<!--										:class="{ 'is-selected': page.url == pagedetail.url }">-->
<!--										{{ page.title }}-->
<!--									</a>-->
<!--									<div v-for="child in page.child" class="docnavindex__item">-->
<!--										<a v-bind:href="currurl + '/' + child.url + '/release'" class="docnavindex-link"-->
<!--											:class="{ 'is-selected': child.url == pagedetail.url }">-->
<!--											{{ child.title }}-->
<!--										</a>-->
<!--									</div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>

                <div v-if="!listpage" class="document">
                    <div class="document-hat">
                        <button class="document-hat__control reset-btn" v-if="!this.guest || this.client === 'neostores' || this.client === 'neo-office' || this.client === 'neopharm' || this.client === 'avesta'" :class="{ 'is-open': refsNavOpen }" @click.prevent="toggleItemControl('refsNavOpen')">
                            <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g fill-rule="evenodd" clip-rule="evenodd" fill="currentColor">
                                    <path
                                        d="M1 2h3v1.813H1V2zm0 2.75v7.5h3v-7.5H1zM1 15v-1.813h3V15H1zM0 2a1 1 0 011-1h3a1 1 0 011 1v13a1 1 0 01-1 1H1a1 1 0 01-1-1V2zm3 4.625H2v3.75h1v-3.75z" />
                                    <path
                                        d="M5 2h3v1.813H5V2zm0 2.75v7.5h3v-7.5H5zM5 15v-1.813h3V15H5zM4 2a1 1 0 011-1h3a1 1 0 011 1v13a1 1 0 01-1 1H5a1 1 0 01-1-1V2zm3 4.625H6v3.75h1v-3.75z" />
                                    <path
                                        d="M9.366 1.803l2.755-.61.41 1.85-2.756.61-.41-1.85zm.617 2.791l1.667 7.533 2.756-.61-1.667-7.533-2.756.61zm2.285 10.324l-.41-1.85 2.756-.61.41 1.85-2.756.61zM8.389 2.019A1 1 0 019.15.827l2.757-.61a1 1 0 011.192.76L16 14.092a1 1 0 01-.76 1.192l-2.756.61a1 1 0 01-1.193-.76L8.39 2.019zm3.86 4.048l-.942.208.834 3.767.941-.208-.833-3.767z" />
                                </g>
                            </svg>
                        </button>
                        <button class="document-hat__control reset-btn" v-if="!this.guest || this.client === 'neostores' || this.client === 'neo-office' || this.client === 'neopharm' || this.client === 'avesta'" :class="{ 'is-open': indexNavOpen }" @click.prevent="toggleItemControl('indexNavOpen')">
                            <svg width="17" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect x="1.5" y=".5" width="13" height="15" rx=".5" stroke="currentColor" />
                                <circle cx="5" cy="4" r="1" fill="currentColor" />
                                <circle cx="5" cy="8" r="1" fill="currentColor" />
                                <circle cx="5" cy="12" r="1" fill="currentColor" />
                                <path d="M8 4h4M8 8h4M8 12h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                        </button>
                        <svg class="document-hat__icon" width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.5 7a.5.5 0 100 1h5a.5.5 0 000-1h-5zM5 9.5a.5.5 0 01.5-.5h5a.5.5 0 010 1h-5a.5.5 0 01-.5-.5zm0 2a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5z"
                                fill="currentColor" />
                            <path
                                d="M9.5 0H4a2 2 0 00-2 2v12a2 2 0 002 2h8a2 2 0 002-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0011 4.5h2V14a1 1 0 01-1 1H4a1 1 0 01-1-1V2a1 1 0 011-1h5.5z"
                                fill="currentColor" />
                        </svg>
                        <span class="document-hat__txt">
                            {{ pagedetail.title }}
                        </span>
                    </div>
                    <div class="document-content" ref="documentText"></div>
                </div>
                <div v-else class="docrefs">
                    <div class="docrefs-list">
                        <div v-for="software in software" class="docrefs-group">
                            <div class="docrefs-group-hat">
                                <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#prefix__clip0_392_4979)" fill-rule="evenodd" clip-rule="evenodd"
                                        fill="currentColor">
                                        <path
                                            d="M1.5 3H6v2.719H1.5V3zm0 4.125v11.25H6V7.125H1.5zm0 15.375v-2.719H6V22.5H1.5zM0 3a1.5 1.5 0 011.5-1.5H6A1.5 1.5 0 017.5 3v19.5A1.5 1.5 0 016 24H1.5A1.5 1.5 0 010 22.5V3zm4.5 6.938H3v5.624h1.5V9.939z" />
                                        <path
                                            d="M7.5 3H12v2.719H7.5V3zm0 4.125v11.25H12V7.125H7.5zm0 15.375v-2.719H12V22.5H7.5zM6 3a1.5 1.5 0 011.5-1.5H12A1.5 1.5 0 0113.5 3v19.5A1.5 1.5 0 0112 24H7.5A1.5 1.5 0 016 22.5V3zm4.5 6.938H9v5.624h1.5V9.939z" />
                                        <path
                                            d="M14.049 2.705l4.133-.915.614 2.774-4.134.915-.613-2.774zm.926 4.186l2.5 11.299 4.134-.915-2.5-11.298-4.134.914zm3.427 15.486l-.614-2.775 4.133-.914.614 2.774-4.133.915zM12.584 3.029a1.5 1.5 0 011.14-1.789l4.134-.914a1.5 1.5 0 011.789 1.14L24 21.138a1.5 1.5 0 01-1.14 1.789l-4.134.914a1.5 1.5 0 01-1.789-1.14L12.584 3.029zm5.79 6.072l-1.413.313 1.25 5.65 1.412-.312-1.25-5.65z" />
                                    </g>
                                    <defs>
                                        <clipPath id="prefix__clip0_392_4979">
                                            <path fill="#fff" d="M0 0h24v24H0z" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <span>{{ software.name }}</span>
                            </div>
                            <div v-for="version in software.versions">
								<div class="docrefs-group-version">
									<span>{{ version.name }}</span>
								</div>
								<div v-for="doc in version.docs" class="docrefs-group-links">
									<a v-if="client"
										v-bind:href="'/docs/' + client + '/' + software.url + '/' + version.number + '/' + doc.url"
										class="docrefs-group-links__link">
										{{ doc.name }}
									</a>
									<span v-else class="docrefs-group-links__link">
										{{ doc.name }}
									</span>
								</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { nextTick, version } from 'vue';

export default {
    name: "DocumentationComponent",
    props: [
        'listpage',
        'client',
        'pagedetail',
        'currurl',
        'software',
        'content',
        'release',
        'guest',
        'show_list_documents',
        'page_search'
    ],
    data() {
        return {
            refsNavOpen: true,
            indexNavOpen: true,
            documentOpen: true,
            refsOpen: true,
            gridModClass: this.listpage ? '' : (!this.guest || this.client === 'neostores' || this.client === 'neo-office' || this.client === 'neopharm' || this.client === 'avesta' ? 'documentation-grid_has-two-nav-items' : 'documentation-grid_has-no-nav-items'),
            startPage: true,
            suggestionsHidden: true,
            docnavGroupIDs: [],
            searchResult: [],
            searchQuery: '',
            screenWidth: window.innerWidth,
        };
    },
	created() {
		axios.post('/docs/checkRole', '')
			.then(res => {
				if(res.data == 'editor') {
					let link = '/docs-edit';
					document.getElementById('doc_edit_link').innerHTML = '<a href="' + link + '" class="text-decoration-none"><div class="doc-edit-link">Список документов</div></a>';
				}
			}
        );
    },
    methods: {
        toggleItemControl: function (propName) {
            this[propName] = !this[propName];
            this.toggleGridModClass();
        },
        toggleGridModClass: function () {
            if ((this.refsNavOpen + this.indexNavOpen) == 2) {
                this.gridModClass = 'documentation-grid_has-two-nav-items';
            } else if ((this.refsNavOpen + this.indexNavOpen) == 0) {
                this.gridModClass = 'documentation-grid_has-no-nav-items';
            } else {
                this.gridModClass = '';
            }
        },
        toggleGroup: function ($event) {
            $event.currentTarget.classList.toggle('is-open');

            if ($event.currentTarget.classList.value.includes('is-open')) {
                localStorage.setItem($event.currentTarget.id, true);
            } else {
                localStorage.removeItem($event.currentTarget.id);
            }
        },
        getDocnavGroupIDs (elementId) {
            return {
                'is-open': Boolean(localStorage.getItem(elementId))
            }
        },
        togglePage: function () {
            this.startPage = false;
            this.indexNavOpen = true;
            this.toggleGridModClass();
        },
        // toggleSuggestions: function ($event) {
        //     $event.currentTarget.value.trim().length > 2 ? this.suggestionsHidden = false : this.suggestionsHidden = true;
        //     if (!this.suggestionsHidden) {
        //         document.body.addEventListener('click', this.closeSearchSuggestionsOnClickOutside);
        //         window.addEventListener('keydown', this.closeSearchSuggestionsOnEsc);
        //     } else {
        //         document.body.removeEventListener('click', this.closeSearchSuggestionsOnClickOutside);
        //         window.removeEventListener('keydown', this.closeSearchSuggestionsOnEsc);
        //     }
        // },
        // closeSearchSuggestionsOnClickOutside: function (e) {
        //     if (!e.target.closest('.search-control')) {
        //         this.suggestionsHidden = true;
        //     } else {
        //         this.suggestionsHidden = false;
        //     }
        // },
        // closeSearchSuggestionsOnEsc: function (e) {
        //     if (e.key === 'Escape') {
        //         this.suggestionsHidden = true;
        //     }
        // },

		// searchData: function () {

		// 	const searchData = {
		// 		string: document.getElementById('search-control__input').value,
		// 		client: this.client
		// 	};
		// 	axios.post('/docs/search', searchData)
		// 		.then(res => {

		// 			var search_software = '';
		// 			res.data.softwareList.forEach(software => {
		// 				search_software += '<div class="docnavsearch-refs-group"><button class="docnavsearch-refs-group-control search-software reset-btn" ><span>' + software.name + '</span><svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.5 5.5l-5 5-5-5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /></svg></button><div class="docnavsearch-refs-group-panel">';
		// 				res.data.versionsList.forEach(version => {
		// 					search_software += '<div>';
		// 					if(software.id == version.sw_id) {
		// 						search_software += '<div class="docrefs-group-version"><span>' + version.number + ' - ' + version.name + '</span></div>';
		// 						res.data.docsList.forEach(doc => {
		// 							search_software += '<div>';
		// 							if(version.id == doc.vers_id) {
		// 								search_software += '<div>';
		// 								if(res.data.client) {
		// 									search_software += '<a href="/docs/' + res.data.client + '/' + software.url + '/' + version.number + '/' + doc.url + '" class="docnavsearch-refs-link"><span>' + doc.name + '</span></a>';
		// 								} else {
		// 									search_software += '<span v-else class="docnavsearch-refs-link">' + doc.name + '</span>';
		// 								}
		// 								search_software += '</div>';
		// 							}
		// 							search_software += '</div>';
		// 						});
		// 					}
		// 					search_software += '</div>';
		// 				});
		// 				search_software += '</div></div>';

		// 			});

		// 			var objects = document.getElementsByClassName('docnavsearch-refs');
		// 			for(var obj of objects) {
		// 				obj.innerHTML = search_software;
		// 			}

		// 			var sr_objects = document.getElementsByClassName('docnavsearch-refs-group-control search-software');
		// 			const buttonPressed = (e) => {
		// 				e.currentTarget.classList.toggle("is-open");
		// 			}
		// 			for(var obj of sr_objects) {
		// 				obj.addEventListener("click", buttonPressed);
		// 			}
		// 		})
        // },

        highlightSelectedElement() {
            let currentUrl = window.location.href
            let navLinksArray = document.querySelectorAll('.docnavsearch-refs-link')
            for (let element of navLinksArray) {
                if (currentUrl.includes(element.getAttribute('href'))) {
                    element.classList.add('selected')
                }
            }
        },

        scrollToHighlighted() {
            nextTick(() => {
                const highlightedElement = this.$el.querySelector('.selected');
                if (highlightedElement) {
                    highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },

        redirectToSearch() {
            // const query = this.searchQuery.trim();
            // if (!query || query.length < 3) return;
            //
            // // Выполняем редирект
            // const queryString = new URLSearchParams({
            //     q: query,
            // }).toString();

            window.location.href = this.page_search;
        },

        async navSearch() {
            // this.searchQuery = this.$refs.searchInput.value.trim();
            //
            // if (!this.searchQuery || this.searchQuery.length < 3) {
            //     return;
            // }

            this.redirectToSearch();

            // let openElements = document.querySelectorAll('.reset-btn');
            // openElements.forEach(element => {
            //     if (!Boolean(localStorage.getItem(element.id))) {
            //         element.classList.remove('is-open');
            //     }
            // });

            //Поиск на бэкенде
            // const softwareFullTextSearch = await axios.post(
            //     '/docs/search/deep',
            //     {
            //         query: this.searchQuery,
            //         client: this.client
            //     }
            // );
            //this.searchResult = softwareFullTextSearch.data.software;
            //window.location.href = this.deep_search_page;
            // this.navSearchFilter();

            // Поиск на фронтенде
            // Заполняем массив this.searchResult элементами this.software
        //     this.software.forEach(software => {
        //         if (software.name.toLowerCase().includes(this.searchQuery) && !this.searchResult.includes(software))
        //         {
        //             this.searchResult.push(software);
        //         }
        //         else
        //         {
        //             if (!software.versions) {
        //                 return;
        //             }
        //             software.versions.forEach(versions => {
        //                 if (versions.name.toLowerCase().includes(this.searchQuery) && !this.searchResult.includes(software))
        //                 {
        //                     this.searchResult.push(software);
        //                 }
        //                 else
        //                 {
        //                     versions.docs.forEach(docs => {
        //                         if (docs.name.toLowerCase().includes(this.searchQuery) && !this.searchResult.includes(software)) {
        //                             this.searchResult.push(software);
        //                         }
        //                     });
        //                 }
        //             });
        //         }
        //     });
        //     this.navSearchFilter();
        },

        navSearchFilter() {
            // Поиск на бэкенде
            this.searchResult.forEach(software => {
                this.$nextTick(() => {
                    document.getElementById(software.id).classList.add('is-open');
                });
            });

            // Поиск на фронтенде
            // Убираем из this.searchResult подкомпоненты this.software по которым нет совпадений с поисковой строкой
            // const searchResultCopy = JSON.parse(JSON.stringify(this.searchResult));
            // searchResultCopy.forEach(software => {
            //     // Поиск на фронтенде
            //     if (!software.versions || software.name.toLowerCase().includes(this.searchQuery.toLowerCase())) {
            //         return;
            //     }
            //
            //     software.versions.forEach(versions => {
            //         versions.docs = [...versions.docs.filter(docs => docs.name.toLowerCase().includes(this.searchQuery.toLowerCase()))];
            //     });
            //
            //     this.searchResult = searchResultCopy;
            //
            //     this.$nextTick(() => {
            //         document.getElementById(software.id).classList.add('is-open');
            //     });
            // });
        }
    },

	mounted() {
        this.scrollToHighlighted()
        this.highlightSelectedElement()
		if(!this.listpage) {
			this.$refs.documentText.innerHTML = this.pagedetail.text;
		}
    },
};
</script>

<style scoped>
    .selected {
        background-color: #c1ecff;
    }
</style>
